/* globals console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    //
    templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'filters-list-item-wrapper'
    },
    events: {
        'click button': 'onClickRemove'
    },
    tagName: 'div',
    template: templates.filtersListItem,
    initialize: function () {
        this.listenTo(this.model, 'change', _.bind(function () {
            this.render();
        }, this));
        this.templateContext = this.options;
    },
    onClickRemove: function (event) {
        this.trigger('remove:filter', event.currentTarget.dataset.group);
        return false;
    }
});
